<script setup lang="ts">
import { DropdownMenuItem, type DropdownMenuItemProps } from "radix-vue"
import { cn } from "@/lib/utils"

const props = defineProps<
  DropdownMenuItemProps & { inset?: boolean; class?: string }
>()
</script>

<template>
  <DropdownMenuItem
    v-bind="props"
    :class="[
      cn(
        'focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center rounded-sm px-2 py-1.5 text-sm outline-hidden transition-colors select-none data-disabled:pointer-events-none data-disabled:opacity-50',
        inset && 'pl-8',
        props.class
      ),
    ]"
  >
    <slot />
  </DropdownMenuItem>
</template>
